<app-modal [active]="true" (modalClosed)="closeDialog()">
    <p>Leider gibt es für das Objekt <span class="is-bold">{{property.name}}
        : {{property.street}} {{property.house_number}} {{property.zip}}</span> noch keine neuen Dokumente.</p>
    <p>Möchten Sie stattdessen alle Dokumente für dieses Objekt herunterladen?</p>
    <div class="columns" style="margin-top: 15px">
        <div class="column is-one-third">
            <a (click)="closeDialog()" class="button back-button is-size-6 has-round-border"
               style="border:none;">
                <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                    <div class="column">
                        <p class="is-bold" style="padding-bottom: 10px;">Zurück</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="column is-one-third"></div>
        <div class="column is-one-third">
            <a (click)="downloadAllDocumentsForProperty(property)"
               class="button buy-button is-size-6 has-round-border" style="border:none;">
                <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                    <div class="column is-bold"><p style="padding-bottom: 10px">Dokumente herunterladen</p></div>
                </div>
            </a>
        </div>
    </div>
</app-modal>
